import { setRemoteDefinitions } from '@nx/angular/mf';
import { ENVIRONMENT } from '@sbg-web/env';

fetch(`/assets/${ENVIRONMENT.manifest}`)
    .then((res) => res.json())
    .then((definitions) => setRemoteDefinitions(definitions))
    .then(() => import('./bootstrap').catch((err) => console.error(err)));
